import React, { useState, useEffect } from 'react';
import { api_addBanner } from '../../../api/banner';
import { api_getOffers } from '../../../api/offer';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const AddBanner = () => {
	const [loading, setLoading] = useState(false);
	const [image, setImage] = useState<File | null>(null);
	const [offers, setOffers] = useState<any[]>([]); // State to hold offers
	const [selectedOffer, setSelectedOffer] = useState<string>(''); // State to hold selected offer ID
	const navigate = useNavigate();

	useEffect(() => {
		fetchOffers(); // Fetch offers on component mount
	}, []);

	const fetchOffers = async () => {
		try {
			const response = await api_getOffers(); // Assuming api_getOffers fetches the list of offers
			setOffers(response.data); // Assuming response.data is an array of offer objects
		} catch (error) {
			console.error('Error fetching offers:', error);
			toast.error('Failed to fetch offers');
		}
	};

	const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files && event.target.files[0]) {
			setImage(event.target.files[0]);
		}
	};

	const handleOfferChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		setSelectedOffer(event.target.value);
	};

	const addBanner = async () => {
		try {
			setLoading(true);
			if (!image) {
				toast.error('Please select an image');
				return;
			}
			if (!selectedOffer) {
				toast.error('Please select an offer');
				return;
			}

			const formData = new FormData();
			formData.append('image', image);
			formData.append('offer', selectedOffer);

			const res = await api_addBanner(formData);
	 // Debugging: Check the response

			const message = typeof res.message === 'string' ? res.message : 'Success';
			if (res.isSuccess) {
				toast.success(message);
				setTimeout(() => {
					navigate('/banner');
				}, 1000); // Navigate to banners list after 1 second
			} else {
				toast.error('Failed to add banner');
			}
		} catch (error) {
			console.error('Error adding banner:', error);
			toast.error('An error occurred while adding banner');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				flex: 1,
				padding: '40px',
			}}>
			<div className='mb-3'>
				<label htmlFor='image' className='form-label'>
					Banner Image
				</label>
				<input
					onChange={handleImageChange}
					style={{ width: '100%', maxWidth: '400px' }}
					className='form-control form-control-sm'
					id='image'
					type='file'
					accept='image/*'
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='offer' className='form-label'>
					Select Offer
				</label>
				<select
					id='offer'
					className='form-select'
					value={selectedOffer}
					onChange={handleOfferChange}>
					<option value=''>Select an offer</option>
					{offers.map((offer) => (
						<option key={offer._id} value={offer._id}>
							{offer.name}
						</option>
					))}
				</select>
			</div>
			<button
				onClick={addBanner}
				type='button'
				className='btn btn-lg btn-primary'
				disabled={loading || !image || !selectedOffer}>
				{loading ? 'Loading...' : 'Add Banner'}
			</button>
		</div>
	);
};

export default AddBanner;
